import React from 'react';

const GLYPHS = {
  up: {
    viewBox: '0 0 12 8',
    path:
      'M5.29 0.709996L0.700001 5.3C0.310001 5.69 0.310001 6.32 0.700001 6.71C1.09 7.1 1.72 7.1 2.11 6.71L6 2.83L9.88 6.71C10.27 7.1 10.9 7.1 11.29 6.71C11.68 6.32 11.68 5.69 11.29 5.3L6.7 0.709996C6.32 0.319996 5.68 0.319996 5.29 0.709996Z'
  },
  down: {
    viewBox: '0 0 14 8',
    path:
      'M9.88 1.29L6 5.17L2.12 1.29C1.73 0.899998 1.1 0.899998 0.71 1.29C0.32 1.68 0.32 2.31 0.71 2.7L5.3 7.29C5.69 7.68 6.32 7.68 6.71 7.29L11.3 2.7C11.69 2.31 11.69 1.68 11.3 1.29C10.91 0.909998 10.27 0.899998 9.88 1.29V1.29Z'
  }
};

type FilterChevronProps = {
  open: boolean;
  color?: string;
};

const FilterChevron = ({ open, color = '#515253' }: FilterChevronProps) => {
  const { viewBox, path } = GLYPHS[open ? 'up' : 'down'];
  return (
    <svg
      width="16px"
      height="16px"
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid={`filter-chevron-${open ? 'up' : 'down'}`}
    >
      <path fill={color} d={path} />
    </svg>
  );
};

export default FilterChevron;
